import React from 'react';
import NoDataRow from "../../../../../components/reports/no-data-row.jsx";

const MaterialCautionContent = ({ garrison, showDetails }) => {
    if (!showDetails) return null;
    const data = garrison?.materialCaution;

    return (
        <tr>
            <td colSpan={12} style={{ padding: 0 }}>
                <table className="w-full my-4">
                    <thead>
                        <tr>
                            <th colSpan={6} className="headerTitle text-zinc-600">
                                Materiais em cautela do plantão
                            </th>
                        </tr>

                        <tr className={'divisor-header text-zinc-600'}>
                            <th className={'w-[22%]'}>Material</th>
                            <th className={'w-[15%]'}>Nº de série</th>
                            <th className={'w-[15%]'}>Nº de patrimônio</th>
                            <th className={'w-[14%]'}>Retirada</th>
                            <th className={'w-[14%]'}>Devolução</th>
                            <th className={'w-[20%]'}>Integrante</th>
                        </tr>
                    </thead>

                    <tbody>
                        {!data?.length ? (
                            <NoDataRow colSpan={6} message={"Nenhum registro encontrado."} tdClassName="" alertClassName=""/>
                        ) : data.map((element, index) => (
                            <tr key={index} style={{borderBottom: '1px solid #e7eaec'}}>
                                <td className={'w-[22%]'}>{element.material}</td>
                                <td className={'w-[15%]'}>{element.serial ?? ""}</td>
                                <td className={'w-[15%]'}>{element.asset ?? ""}</td>
                                <td className={'w-[14%]'}>{element.caution_date ?? ""}</td>
                                <td className={'w-[14%]'}>{element.return_date ?? ""}</td>
                                <td className={'w-[20%]'}>{element.responsible_name}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </td>
        </tr>
    );
};

export default MaterialCautionContent;
